export default "__VITE_ASSET__Bxo1u9aK__"